<template>
    <div class="footerImages">
        <img v-if="itemData?.footerImage1?.display"  :src="itemData?.footerImage1?.url" alt="" @click="goToPath(itemData?.footerImage1?.redirectUrl)">
        <div class="middleTextImg">
            <img v-if="itemData?.footerImage2?.display"  :src="itemData?.footerImage2?.url" alt=""  @click="goToPath(itemData?.footerImage2?.redirectUrl)">
            <div v-if="itemData?.htmlFooterTextTop?.display" class="middleText" v-html="itemData?.htmlFooterTextTop?.text"></div>
        </div>

        <img v-if="itemData?.footerImage3?.display"  :src="itemData?.footerImage3?.url" alt="" @click="openContactPopup">
    </div>
    <div class="footerImages">
        <img v-if="itemData?.footerImage4?.display"  :src="itemData?.footerImage4?.url" alt=""  @click="goToPath(itemData?.footerImage4?.redirectUrl)">
    </div>
    <div class="footerImages2">
        <img v-if="itemData?.footerImage5?.display"  :src="itemData?.footerImage5?.url" alt=""  @click="goToPath(itemData?.footerImage1?.redirectUrl)">
    </div>

</template>

<script setup lang="ts">
import { FooterImagesItem, useNavigation } from '@/view/home/supportScript';
import { defineEmits, defineProps } from 'vue'
const { goToPath } = useNavigation()
const emits = defineEmits(['openContactPopup'])
const props = defineProps<{
    itemData: {
        footerImage1: FooterImagesItem,
        footerImage2: FooterImagesItem,
        footerImage3: FooterImagesItem,
        footerImage4: FooterImagesItem,
        footerImage5: FooterImagesItem,
        htmlFooterTextTop: {
            display : boolean
            text: string
        }
    }
}>()
const openContactPopup = () => {
    emits('openContactPopup')
}
</script>
<style scoped>
.footerImages {
    padding: 10px 10px 20px;
    border-bottom: 2px solid #b9b386;
}

.footerImages img {
    width: 100%;
}

.footerImages2 {
    padding: 10px 20px;
}

.footerImages2 img {
    width: 100%;
}

.middleTextImg {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 15px 10px;
}

.middleTextImg img {
    width: 120px;
}

.middleText {
    color: #fff;
    font-size: 15px;
    padding: 15px 0;
    text-align: center;
}
</style>